/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $, SCS) {
	'use strict';
	/*jslint plusplus: true */

	/**
	 * Accordion.
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module
	 * @class Accordion
	 * @extends Tc.Module
	 */

	var groupCount = 0;
	var groupCache = {};

	Module.Accordion = Module.extend({
		// True if one of the tabs has been clicked upon
		hasBeenClicked: false,
		// All the tabs, all the tabs, all the tabs you should have given.
		// All the tabs, all the tabs, all the tabs we could have given.
		tabs: null,
		syncedInitCounter: {},

		/**
		 * Does all the work.
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var $ctx = this.$ctx;
			this.tabs = $ctx.find('.scs-accordion-tab');
			this.isSynchronizedAccordion = $ctx.is('.synchronizedaccordion');
			this.groupId = $ctx.data('group-id') || '';
			this.groupSelector = '.modAccordion.synchronizedaccordion.' + this.groupId;
			// make sure we do not sync accross different tabs
			var parent = $ctx.closest('.modTabNavigationContent');
			if (parent.length) {
				if (!parent.data('sync-root-id')) {
					groupCount += 1;
					parent.attr('data-sync-root-id', groupCount);
				}
				var syncId = parent.data('sync-root-id');
				this.groupSelector = '[data-sync-root-id=' + syncId + '] ' + this.groupSelector;
			}
			this.setupAccordion($ctx);
			callback();
		},

		/**
		 * Called when all modules have been set up
		 */
		after: function () {
			var mod = this,
				$row,
				_groupCache = groupCache[this.groupSelector];

			if(!mod.isSynchronizedAccordion) {
				return;
			}

			// only cache the nodes once per group
			if (!_groupCache) {
				_groupCache = {};
				_groupCache.$group = $(this.groupSelector);
				_groupCache.$sections = mod.$ctx.find('>DIV>.synchronizedaccordion.section');
				_groupCache.tabs = [];
				_groupCache.groupRowSegments = [];

				// Aggregate and cache all row segments within a single group.
				for (var i = 0, sectionLength = _groupCache.$sections.length; i < sectionLength; i += 1) {
					$row = _groupCache.$group.find('.synchronizedaccordion.section:nth-child(' + (i + 1) + ')');
					_groupCache.tabs.push($row.find('.scs-accordion-tab'));
					_groupCache.groupRowSegments.push([
						$row.find('.scs-accordion-tab-heading'),
						$row.find('.scs-accordion-tab-panel'),
						$row.find('.scs-accordion-tab-footer')
					]);
				}
			}

			// only register once for each group
			if (!_groupCache.hasListener) {
				// don't sync group with only one item
				// need at least two to sync something
				if (_groupCache.$group.length > 1) {
					// register sync height event handler
					// try to sync only items in the same "row"
					$(mod.$ctx).parents('BODY, .single-row, .row')
						.on('sync-heights', function (event) {
							event.stopPropagation();
							mod.synchronizeRowHeights();
						});

					// remember that we have bound a handler
					_groupCache.hasListener = true;
					// store the group cache accessibly to all instances.
					groupCache[this.groupSelector] = _groupCache;

					// synchronize here once, because the first 'sync-heights' event will be triggered by the window.load event.
					// But the wait for window.load may be long, when there are multiple larger images or other resources on the page.
					// Hence, we want to present a nice layout quickly, but 'sync-heights' will synchronize again with all loaded images.
					mod.synchronizeRowHeights();
					mod.initOpenedTabs();
					mod.disableEmptyTabs();
				}
			}
		},

		/**
		 * Loop through the row contents and synchronize their heights.
		 */
		synchronizeRowHeights: function() {
			var _groupCache = groupCache[this.groupSelector];
			for (var i = 0, iL = _groupCache.groupRowSegments.length; i < iL; ++i) {
				for (var n = 0, nL = _groupCache.groupRowSegments[i].length; n < nL; ++n) {
					SCS.portal.synchronizeHeights(_groupCache.groupRowSegments[i][n]);
				}
			}
		},

		/**
		 * If one accordion tab in a group row was configured to be opened on load,
		 * make sure all others in the row have the same configuration
		 */
		initOpenedTabs:function(){
			var _groupCache = groupCache[this.groupSelector];
			for( var i = 0, tabsLength = _groupCache.tabs.length; i < tabsLength; i += 1) {
				if (_groupCache.tabs[i].is('.scs-accordion-tab-opened')) {
					_groupCache.tabs[i].addClass('scs-accordion-tab-opened');
				}

				_groupCache.tabs[i].each($.proxy(this.finalizeTab, this));
			}
		},

		/**
		 * Check for content in each accordion tab row.
		 * if a row does not define content, disable the whole row.
		 */
		disableEmptyTabs: function() {
			var _groupCache = groupCache[this.groupSelector],
				$tabRow,
				$tabHeadings;
			for( var i = 0, tabsLength = _groupCache.tabs.length; i < tabsLength; i += 1) {
				$tabRow = _groupCache.tabs[i];
				if(!$tabRow.find('.parsysSynchronizedAccordionContent').children().length) {
					$tabHeadings = $tabRow.find('.scs-accordion-tab-heading');
					$tabHeadings.addClass('disabled');
					$tabRow.off('scs-accordion-tab-opening');
					$tabRow.off('scs-accordion-tab-closing');
					$tabHeadings.off('click');
					$tabHeadings.off('synchronizedTabClick');
					$tabHeadings.off('focus');
				}
			}
		},

		/**
		 * Set up tab that should be initially open
		 */
		setupAccordion: function ($ctx) {
			if (!this.tabs.length) {
				return; //Do nothing if no tabs are present
			}
			this.tabs.each($.proxy(this.setupTab, this));

			this.setupOpenTabs();

			if ($ctx.data(Module.Accordion.DATA.ACCORDION.TRACKING)) {
				var trackedName = $ctx.find('.scs-accordion-tab-opened .scs-accordion-tab-heading a').data('tracking-name');
				SCS.tracking.setLandingTabName(trackedName);
			}
		},

		/**
		 * Takes care to set open states of tabs whose indexes appear in the URL as part of a sling selector
		 */
		setupOpenTabs: function () {
			var openTabs = this.openTabsByHash(); // Hash has higher precedence than all other methods
			if (!openTabs.length) {
				openTabs = this.openTabsByDefault();
			}
			this.tabs.removeClass('scs-accordion-tab-opened');
			openTabs.addClass('scs-accordion-tab-opened');
			openTabs.each($.proxy(this.finalizeTab, this));
		},

		/**
		 * Returns all tabs of which the controller tells us they’re open.
		 * This includes tabs opened by the selector (tab-«normalized-tab-name», or legacy: a«no«, «no») or configured to be initially open.
		 */
		openTabsByDefault: function () {
			return this.tabs.filter('[data-is-selected="true"]');
		},

		/**
		 * Returns the tab whose index appear in the URL as part of the hash.
		 */
		openTabsByHash: function () {
			var tab = this.tabs.filter(function () {
				return $(this).data(Module.Accordion.DATA.TAB.OPENER).find('a').attr('href') === window.location.hash;
			}).first();
			return tab;
		},

		/**
		 * Set up individual tab
		 */
		setupTab: function (index, tab) {
			tab = $(tab);

			// Elements
			var opener = tab.children('.scs-accordion-tab-heading');
			var openerEl = $('A, .title', opener);
			if (!openerEl.length) {
				openerEl = opener;
			}
			var panel = tab.children('.scs-accordion-tab-panel');

			// Tab data
			tab.data(Module.Accordion.DATA.TAB.OPENER, opener);
			tab.data(Module.Accordion.DATA.TAB.PANEL, panel);
			tab.data(Module.Accordion.DATA.TAB.LOADED, !panel.attr('data-url')); //Ajax tabs will be loaded when first opened

			// Tab event handlers
			tab.on('scs-accordion-tab-opening', $.proxy(this.handleOpenTab, this, tab));
			tab.on('scs-accordion-tab-closing', $.proxy(this.handleCloseTab, this, tab));
			openerEl.on('click', $.proxy(this.handleClickOpener, this, tab, opener));
			opener.on('synchronizedTabClick', $.proxy(this.handleClickOpener, this, tab, opener));
			opener.on('focus', $.proxy(this.handleFocusOpener, this, tab, opener));

			// Additional setup
			openerEl.prop('tabindex', -1); //Make the opener focusable
			openerEl.css('cursor', 'pointer'); //Is a clickable element

		},

		/**
		 * Updates the tab data properties to sync with the state represented by the actual class names
		 */
		finalizeTab: function (index, tab) {
			tab = $(tab);

			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, tab.is('.scs-accordion-tab-opened'));

			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN)) {
				this.openTab(tab);
			}
		},

		/**
		 * Makes sure newly opened tabs are correctly configured (with loaded content)
		 */
		handleOpenTab: function (tab) {
			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, 'opening');
			this.loadTab(tab, function (panel) {
				panel.slideDown($.proxy(this.tabOpened, this, tab));
			});
		},

		/**
		 * Called when the open animation has finished. This is mostly to update classes and to focus the opener.
		 * If there is a carousel inside the panel, it may have to be re-rendered.
		 */
		tabOpened: function (tab) {
			var opener = tab.data(Module.Accordion.DATA.TAB.OPENER);
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);

			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, true);
			tab.addClass('scs-accordion-tab-opened').trigger('scs-accordion-tab-opened');
			opener.trigger('focus');
			panel.attr('aria-hidden', 'false');

			$(document).trigger('element-shown', [panel]);
		},

		/**
		 * Makes sure newly closed tabs are correctly disposed of
		 */
		handleCloseTab: function (tab, event) {
			//Prevent closing Parent tab
			event.stopPropagation();
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);
			tab.data(Module.Accordion.DATA.TAB.IS_OPEN, null);
			panel.slideUp(function () {
				tab.data(Module.Accordion.DATA.TAB.IS_OPEN, false);
				tab.removeClass('scs-accordion-tab-opened').trigger('scs-accordion-tab-closed');
				panel.attr('aria-hidden', 'true');
				tab.find($('a').each(function(){this.onmouseup = this.blur();}));
			});
		},

		/**
		 * Handles tab heading clicks
		 */
		handleClickOpener: function (tab, opener, event) {
			event.preventDefault();
			event.stopPropagation();

			// not needed to set to false after this line, openBySelector event has already happened
			this.hasBeenClicked = true;

			//Disallow clicks while loading, and during opening and closing
			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN) === 'opening' || tab.data(Module.Accordion.DATA.TAB.IS_OPEN) === null) {
				return;
			}
			if (tab.data(Module.Accordion.DATA.TAB.IS_OPEN)) {
				this.closeTab(tab);
			}
			else {
				this.openTab(tab);
			}

			if (this.$ctx.data(Module.Accordion.DATA.ACCORDION.TRACKING) && event.type === 'click') {
				var trackedName = opener.find('a').data('tracking-name');
				SCS.tracking.trackPartialPageView(trackedName);
			}

			if (groupCache[this.groupSelector] && groupCache[this.groupSelector].$group.length > 1 && event.type !== 'synchronizedTabClick') {
				var index = opener.closest('.synchronizedaccordion.section').index();
				groupCache[this.groupSelector].$group.find('.synchronizedaccordion.section:eq(' + index + ')')
					.find('.scs-accordion-tab-heading')
					.trigger('synchronizedTabClick');
			}
		},

		/**
		 * When the opener gets focus, make sure to scroll so the content is visible
		 */
		handleFocusOpener: function (tab, op, event) {
			event.preventDefault();

			var opener = tab.data(Module.Accordion.DATA.TAB.OPENER);
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);
			var offset = opener.offset();

			if (this.hasBeenClicked && panel.height() && ( $(window).scrollTop() + $(window).height() < offset.top + panel.outerHeight(true) + opener.outerHeight(true) )) {
				window.scrollTo(0, offset.top);
			}
		},

		/**
		 * Makes sure the tab content is loaded
		 */
		loadTab: function (tab, callback) {
			var mod = this;
			var panel = tab.data(Module.Accordion.DATA.TAB.PANEL);

			if (tab.data(Module.Accordion.DATA.TAB.LOADED) === 'loading') {
				return; //Drop the callback because the one that’s gonna be executed on finish is probably the same
			} else if (tab.data(Module.Accordion.DATA.TAB.LOADED)) {
				return callback.call(mod, panel);
			} else {
				tab.data(Module.Accordion.DATA.TAB.LOADED, 'loading'); // "loading" is the intermediate status
				panel.load(panel.attr('data-url'), function () {
					tab.data(Module.Accordion.DATA.TAB.LOADED, true);
					callback.call(mod, panel);
				});
			}
		},

		/**
		 * Opens an individual tab
		 *
		 * @argument tab Either the tab element or a (0-indexed) tab number
		 */
		openTab: function (tab) {
			if (typeof tab === 'number') {
				tab = this.tabs.eq(tab);
			}
			tab.trigger('scs-accordion-tab-opening');
		},

		/**
		 * Closes an individual tab
		 *
		 * @argument tab Either the tab element or a (0-indexed) tab number
		 */
		closeTab: function (tab) {
			if (typeof tab === 'number') {
				tab = this.tabs.eq(tab);
			}
			tab.trigger('scs-accordion-tab-closing');
		}
	});

	Module.Accordion.DATA = {
		ACCORDION: {
			TRACKING: 'tracking-enabled'
		},
		TAB: {
			IS_OPEN: 'modAccordion-isOpen', //Possible values: true, 'opening', false, null (closing)
			OPENER: 'modAccordion-opener',
			PANEL: 'modAccordion-panel',
			LOADED: 'modAccordion-hasBeenLoaded'
		}
	};
}(window.Tc.Module, window.Tc.$, window.SCS, window.debug || window.console));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.js
// module id = 127
// module chunks = 0